import PropTypes from 'prop-types';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';
import { t } from 'i18next';

/**
 * A functional component that renders a date picker for selecting a birthdate.
 */
export const BirthdatePicker = ({ values, handleChange, errors, touched }) => (
    <LocalizationProvider dateAdapter={AdapterDateFns}>
        <DatePicker
            value={values.birthdate || null}
            onChange={(value) => handleChange({ target: { name: 'birthdate', value } })}
            name="birthdate"
            label={t('users.fields.birthDate')}
            format="dd/MM/yyyy"
            sx={{ width: '100%' }}
            error={touched.birthdate && Boolean(errors.birthdate)}
            helperText={touched.birthdate && errors.birthdate}
            slotProps={{
                openPickerButton: {
                    color: 'secondary'
                },
                inputAdornment: {
                    position: 'start'
                }
            }}
        />
    </LocalizationProvider>
);

BirthdatePicker.propTypes = {
    values: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired,
    errors: PropTypes.object.isRequired,
    touched: PropTypes.object.isRequired
};
